import React, { useState, useEffect } from 'react';
import { Col, Row } from 'antd';

export function PoliticasDeSenha({ senha }) {
  const [regrasSenha, setRegrasSenha] = useState({
    minimoCaracteres: false,
    letraMaiuscula: false,
    letraMinuscula: false,
    caracterEspecial: false,
    numero: false,
  });

  const verificaPoliticasDeSenha = () => {
    setRegrasSenha({
      ...regrasSenha,
      minimoCaracteres: senha.length >= 8,
      letraMaiuscula: !!senha.match('[A-Z]'),
      letraMinuscula: !!senha.match('[a-z]'),
      caracterEspecial: !!senha.match('[^0-9a-zA-Z]+'),
      numero: !!senha.match('[0-9]'),
    });
  };

  useEffect(() => {
    verificaPoliticasDeSenha();
  }, [senha]);

  return (
    <Col
      style={{
        flexDirection: 'column',
        fontSize: '12px',
        color: '#828282',
        marginBottom: '32px',
      }}
    >
      <Row style={{ color: regrasSenha.minimoCaracteres ? '#24a95d' : 'red' }}>
        Mínimo de 8 caracteres.
      </Row>
      <Row style={{ color: regrasSenha.letraMaiuscula ? '#24a95d' : 'red' }}>
        Mínimo 1 letra maiúscula.
      </Row>
      <Row style={{ color: regrasSenha.letraMinuscula ? '#24a95d' : 'red' }}>
        Mínimo 1 letra minúscula.
      </Row>
      <Row style={{ color: regrasSenha.caracterEspecial ? '#24a95d' : 'red' }}>
        Mínimo 1 caráter especial.
      </Row>
      <Row style={{ color: regrasSenha.numero ? '#24a95d' : 'red' }}>
        Mínimo 1 número.
      </Row>
    </Col>
  );
}
